import { useMutation } from "react-query";
import { ContaForm } from "../typings";
import http from "infra/http";
import { showErrorAxios } from "infra/helpers/alerta";
import { OperacaoEnum } from "core/resources/enums/conta";
import { AxiosError } from "axios";

function useSaveConta(operacao: OperacaoEnum) {
  return useMutation<{ data: string }, AxiosError<string>, ContaForm, unknown>(
    async (form: ContaForm) => {
      const _data = { ...form, operacao };

      if (_data.dataCompetencia?.length === 7) {
        _data.dataCompetencia = `${_data.dataCompetencia}-01`;
      }

      if (form.id) {
        return http.put(`/v1/conta/${form.id}`, _data);
      }

      const { data } = await http.post(`/v1/conta`, _data);
      return data;
    },
    {
      retry: false,
      onError: (e) => {
        showErrorAxios(e);
      },
    }
  );
}

export default useSaveConta;
